<template>
  <v-card
    :style="{borderRadius}"
    :color="color"
    :elevation="elevation"
    :hover="hover"
    :ripple="ripple"
    :to="to"
    @click="event => $emit('click', event)"
  >
    <slot />
  </v-card>
</template>

<script>
export default {
  props: {
    /**
     * The border radius for the round corners.
     */
    borderRadius: {
      type: String,
      default: "15px"
    },
    /**
     * The color of the card.
     */
    color: {
      type: String
    },
    /**
     * The elevation of the card.
     */
    elevation: {
      type: Number,
      default: 0
    },
    /**
     * Apply a higher elevation on hover.
     */
    hover: {
      type: Boolean,
      default: false
    },
    /**
     * Apply the v-ripple directive.
     */
    ripple: {
      type: Boolean,
      default: false
    },
    /**
     * Will designate the component tag to `<router-link>`.
     */
    to: {}
  }
};
</script>
